function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCurseforge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    viewBox: "0 0 43 43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m-2005.7 853 .7 3h-12s.2.9.3 1c.3.5.6 1.1 1 1.5 1.9 2.2 5.2 3.1 7.9 3.6 1.9.4 3.8.5 5.7.6l2.2 5.9h1.2l.7 1.9h-1l-1.7 5.5h16.7l-1.7-5.5h-1l.7-1.9h1.2s1-6.1 4.1-8.9c3-2.8 6.7-3.2 6.7-3.2V853h-31.7Zm16.8 15.1c-.8.5-1.7.5-2.3.9-.4.2-.6.8-.6.8-.4-.9-.9-1.2-1.5-1.4-.6-.2-1.7-.1-3.2-1.4-1-.9-1.1-2.1-1-2.7v-.3c0-.1 0-.2.1-.3.2-.6.7-1.2 1.7-1.6 0 0-.7 1 0 2 .4.6 1.2.9 1.9.5.3-.2.5-.6.6-.9.2-.7.2-1.4-.4-1.9-.9-.8-1.1-1.9-.5-2.6 0 0 .2.9 1.1.8.6 0 .6-.2.4-.4-.1-.3-1.4-2.2.5-3.6 0 0 1.2-.8 2.6-.7-.8.1-1.7.6-2 1.4v.1c-.3.8-.1 1.7.5 2.5.4.6.9 1.1 1.1 1.9-.3-.1-.5 0-.7.2-.2.2-.3.6-.2.9.1.2.3.4.5.4h.3c.3-.1.5-.5.4-.8.2.2.3.7.2 1 0 .3-.2.6-.3.8-.1.2-.3.4-.4.6-.1.2-.2.4-.2.6 0 .2 0 .5.1.7.4.6 1.2 0 1.4-.5.3-.6.2-1.3-.2-1.9 0 0 .7.4 1.2 1.8.4 1.2-.3 2.6-1.1 3.1Z",
    style: {
      fill: "#f16436",
      fillRule: "nonzero"
    },
    transform: "translate(2017 -843)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurseforge);
export default __webpack_public_path__ + "static/media/curseforge.b0bcc84f3d419c8d3eb47a2ea09f9cf9.svg";
export { ForwardRef as ReactComponent };